import { SERVER_URI } from '../Constant/server';
import { apiGet, apiPost, apiPut } from '../utils/axios';

const AddEmployee = `${SERVER_URI}/registration/employee`;
const EmployeeList = `${SERVER_URI}/get-employees`;

const updateEmployeeStatus = `${SERVER_URI}/change-employee-status/`;
const UPDATE_EMPLOYEE = `${SERVER_URI}/employees/`;
const RESET_PASSWORD = `${SERVER_URI}/reset-default-password/`;


export default {

  Registration: async function (payload) {
    return await apiPost(AddEmployee, payload);
  },
  bindEmployeeList: async function (payload) {
    return apiPost(EmployeeList, payload);
  },
  updateStatus: async function (id) {
    return apiGet(updateEmployeeStatus + id);
  },
  updateEmployee: async function (id, paylaod) {
    return apiPut(UPDATE_EMPLOYEE + id, paylaod)
  },
  resetPassword: async function (payload) {
    console.log('password',payload)
    return apiPost(RESET_PASSWORD + payload);
  }
};
